/** The 8 x 8 font: digits, punctuation and the game's symbols (see fontLetters.ts). */
export const SYMBOLS: Readonly<Record<string, string>> = {
  '0': '..####..|.##..##.|.##.###.|.###.##.|.##..##.|.##..##.|..####..|........',
  '1': '...##...|..###...|...##...|...##...|...##...|...##...|.######.|........',
  '2': '..####..|.##..##.|.....##.|....##..|..##....|.##.....|.######.|........',
  '3': '..####..|.##..##.|.....##.|...###..|.....##.|.##..##.|..####..|........',
  '4': '....##..|...###..|..####..|.##.##..|.######.|....##..|....##..|........',
  '5': '.######.|.##.....|.#####..|.....##.|.....##.|.##..##.|..####..|........',
  '6': '..####..|.##.....|.##.....|.#####..|.##..##.|.##..##.|..####..|........',
  '7': '.######.|.....##.|....##..|...##...|...##...|...##...|...##...|........',
  '8': '..####..|.##..##.|.##..##.|..####..|.##..##.|.##..##.|..####..|........',
  '9': '..####..|.##..##.|.##..##.|..#####.|.....##.|....##..|..###...|........',
  ' ': '........|........|........|........|........|........|........|........',
  '.': '........|........|........|........|........|...##...|...##...|........',
  ',': '........|........|........|........|........|...##...|...##...|..##....',
  ':': '........|...##...|...##...|........|...##...|...##...|........|........',
  ';': '........|...##...|...##...|........|...##...|...##...|..##....|........',
  '!': '...##...|...##...|...##...|...##...|........|...##...|...##...|........',
  '?': '..####..|.##..##.|....##..|...##...|...##...|........|...##...|........',
  "'": '...##...|...##...|..##....|........|........|........|........|........',
  '"': '.##..##.|.##..##.|........|........|........|........|........|........',
  '-': '........|........|........|.######.|........|........|........|........',
  '+': '........|...##...|...##...|.######.|...##...|...##...|........|........',
  '/': '......##|.....##.|....##..|...##...|..##....|.##.....|##......|........',
  '(': '....##..|...##...|..##....|..##....|..##....|...##...|....##..|........',
  ')': '..##....|...##...|....##..|....##..|....##..|...##...|..##....|........',
  '%': '.##...##|.##..##.|....##..|...##...|..##....|.##..##.|##...##.|........',
  '#': '.##..##.|.##..##.|########|.##..##.|########|.##..##.|.##..##.|........',
  '*': '........|.##..##.|..####..|########|..####..|.##..##.|........|........',
  '=': '........|........|.######.|........|.######.|........|........|........',
  '<': '....##..|...##...|..##....|.##.....|..##....|...##...|....##..|........',
  '>': '..##....|...##...|....##..|.....##.|....##..|...##...|..##....|........',
  _: '........|........|........|........|........|........|........|########',
  '&': '..###...|.##.##..|..###...|.###.##.|.##.###.|.##..##.|..###.##|........',
  '@': '..####..|.##..##.|.##.###.|.##.###.|.##.....|.##...#.|..####..|........',
  '[': '..####..|..##....|..##....|..##....|..##....|..##....|..####..|........',
  ']': '..####..|....##..|....##..|....##..|....##..|....##..|..####..|........',
  '◆': '...##...|..####..|.######.|########|.######.|..####..|...##...|........',
  '►': '.##.....|.####...|.######.|.#######|.######.|.####...|.##.....|........',
  '◄': '.....##.|...####.|.######.|#######.|.######.|...####.|.....##.|........',
  '▲': '........|...##...|..####..|.######.|########|........|........|........',
  '▼': '........|........|########|.######.|..####..|...##...|........|........',
  '©': '..####..|.#....#.|#..##..#|#.#....#|#.#....#|#..##..#|.#....#.|..####..',
  '♥': '.##..##.|########|########|########|.######.|..####..|...##...|........',
  '■': '########|########|########|########|########|########|########|########',
  '·': '........|........|........|...##...|...##...|........|........|........',
  '♪': '...###..|...#.##.|...#..#.|...#....|.###....|####....|.##.....|........',
  '⌛': '.######.|.#....#.|..#..#..|...##...|..#..#..|.#.##.#.|.######.|........',
  '✓': '........|......##|.....##.|##..##..|.####...|..##....|........|........',
};
